import { QuestionnaireForm } from '../interfaces/reserve-health.model';

// 健康調查表欄位
export const HEALTH_QUESTIONNAIRE_FIELDS = {
  PERSONAL_HISTORY: {
    questionnaireType: '個人病史',
    questionnaireTypeXCode: 'personalhistory',
    diseaseGroups: [
      {
        diseaseType: '慢性疾病',
        questionId: '474',
        diseaseOptions: [
          {
            name: '高血壓',
            choiceId: '1541',
            answer: '2',
          },
          {
            name: '糖尿病',
            choiceId: '1542',
            answer: '3',
          },
          {
            name: '高血脂',
            choiceId: '1543',
            answer: '4',
          },
          {
            name: '其他慢性疾病',
            choiceId: '1566',
            detailPlaceholder: '請輸入慢性病名稱',
            detailPlaceholderId: '1570',
            answer: '27',
          },
          {
            name: '癌症',
            choiceId: '1565',
            detailPlaceholder: '請輸入癌症名稱',
            detailPlaceholderId: '1569',
            answer: '26',
          },
        ],
      },
      {
        diseaseType: '神經系統與腦中風相關疾病',
        questionId: '474',
        diseaseOptions: [
          {
            name: '癲癇',
            choiceId: '1549',
            answer: '10',
          },
          {
            name: '中風',
            choiceId: '1548',
            answer: '9',
          },
        ],
      },
      {
        diseaseType: '眼科與耳鼻喉相關疾病',
        questionId: '474',
        diseaseOptions: [
          {
            name: '白內障',
            choiceId: '1545',
            answer: '6',
          },
          {
            name: '青光眼',
            choiceId: '1546',
            answer: '7',
          },
          {
            name: '黃斑部病變',
            choiceId: '1547',
            answer: '8',
          },
          {
            name: '中耳炎',
            choiceId: '1557',
            answer: '18',
          },
          {
            name: '聽力障礙',
            choiceId: '1558',
            answer: '19',
          },
        ],
      },
      {
        diseaseType: '心肺相關疾病',
        questionId: '474',
        diseaseOptions: [
          {
            name: '心臟病',
            choiceId: '1544',
            answer: '5',
          },
          {
            name: '氣喘',
            choiceId: '1550',
            answer: '11',
          },
          {
            name: '慢性氣管炎',
            choiceId: '1551',
            answer: '12',
          },
          {
            name: '肺氣腫',
            choiceId: '1552',
            answer: '13',
          },
          {
            name: '肺結核',
            choiceId: '1553',
            answer: '14',
          },
        ],
      },
      {
        diseaseType: '肝膽腸胃相關疾病',
        questionId: '474',
        diseaseOptions: [
          {
            name: '肝病',
            choiceId: '1554',
            answer: '15',
          },
          {
            name: '脂肪肝',
            choiceId: '1555',
            answer: '16',
          },
          {
            name: '逆流性食道炎',
            choiceId: '1560',
            answer: '21',
          },
          {
            name: '消化性潰瘍',
            choiceId: '1561',
            answer: '22',
          },
          {
            name: '胃炎',
            choiceId: '1562',
            answer: '23',
          },
        ],
      },
      {
        diseaseType: '肌肉骨骼與外傷相關疾病',
        questionId: '474',
        diseaseOptions: [
          {
            name: '骨折',
            choiceId: '1564',
            detailPlaceholder: '請輸入骨折部位',
            detailPlaceholderId: '1568',
            answer: '25',
          },
        ],
      },
      {
        diseaseType: '其他相關疾病',
        questionId: '474',
        diseaseOptions: [
          {
            name: '過敏',
            choiceId: '1563',
            answer: '20',
          },
          {
            name: '貧血',
            choiceId: '1556',
            answer: '17',
          },
          {
            name: '甲狀腺疾病',
            choiceId: '1559',
            answer: '24',
          },
        ],
      },
    ],
  } as QuestionnaireForm,
  FAMILY_HISTORY: {
    questionnaireType: '家族病史',
    questionnaireTypeXCode: 'familyhistory',
    diseaseGroups: [
      {
        diseaseType: '慢性疾病與癌症相關疾病',
        questionId: '483',
        diseaseOptions: [
          {
            name: '高血壓',
            choiceId: '1593',
            answer: '2',
          },
          {
            name: '糖尿病',
            choiceId: '1595',
            answer: '4',
          },
          {
            name: '高血脂',
            choiceId: '1594',
            answer: '3',
          },
          {
            name: '乳癌',
            choiceId: '1604',
            answer: '13',
          },
          {
            name: '肺癌',
            choiceId: '1605',
            answer: '14',
          },
          {
            name: '胰臟癌',
            choiceId: '1606',
            answer: '15',
          },
          {
            name: '胃 / 大腸癌',
            choiceId: '1607',
            answer: '16',
          },
          {
            name: '卵巢 / 子宮癌',
            choiceId: '1608',
            answer: '17',
          },
        ],
      },
      {
        diseaseType: '心血管與神經系統相關疾病',
        questionId: '483',
        diseaseOptions: [
          {
            name: '心血管疾病',
            choiceId: '1596',
            answer: '5',
          },
          {
            name: '腦血管疾病',
            choiceId: '1597',
            answer: '6',
          },
          {
            name: '失智症',
            choiceId: '1609',
            answer: '18',
          },
        ],
      },
      {
        diseaseType: '免疫與血液疾病',
        questionId: '483',
        diseaseOptions: [
          {
            name: '自體免疫疾病',
            choiceId: '1602',
            answer: '11',
          },
          {
            name: '貧血',
            choiceId: '1598',
            answer: '7',
          },
          {
            name: '白血病',
            choiceId: '1603',
            answer: '12',
          },
        ],
      },
      {
        diseaseType: '肝膽腸胃腎相關疾病',
        questionId: '483',
        diseaseOptions: [
          {
            name: '慢性肝炎或肝硬化',
            choiceId: '1599',
            answer: '8',
          },
          {
            name: '腎臟疾病',
            choiceId: '1600',
            answer: '9',
          },
        ],
      },
      {
        diseaseType: '其他相關疾病',
        questionId: '483',
        diseaseOptions: [
          {
            name: '甲狀腺疾病',
            choiceId: '1601',
            answer: '10',
          },
        ],
      },
    ],
  } as QuestionnaireForm,
  SUBJECTIVE_SYMPTOMS: {
    questionnaireType: '自覺症狀',
    questionnaireTypeXCode: 'subjective_symptoms',
    diseaseGroups: [
      {
        diseaseType: '頭頸部症狀',
        questionId: '472',
        diseaseOptions: [
          {
            name: '頭暈',
            choiceId: '1511',
            answer: '2',
          },
          {
            name: '頭痛',
            choiceId: '1512',
            answer: '3',
          },
          {
            name: '視力模糊',
            choiceId: '1513',
            answer: '4',
          },
          {
            name: '耳鳴',
            choiceId: '1514',
            answer: '5',
          },
          {
            name: '牙齦出血',
            choiceId: '1517',
            answer: '8',
          },
        ],
      },
      {
        diseaseType: '胸部症狀',
        questionId: '472',
        diseaseOptions: [
          {
            name: '咳嗽',
            choiceId: '1515',
            answer: '6',
          },
          {
            name: '咳痰',
            choiceId: '1516',
            answer: '7',
          },
          {
            name: '呼吸困難',
            choiceId: '1518',
            answer: '9',
          },
          {
            name: '胸痛',
            choiceId: '1519',
            answer: '10',
          },
          {
            name: '心悸',
            choiceId: '1520',
            answer: '11',
          },
        ],
      },
      {
        diseaseType: '腹部症狀',
        questionId: '472',
        diseaseOptions: [
          {
            name: '噁心',
            choiceId: '1523',
            answer: '14',
          },
          {
            name: '腹痛',
            choiceId: '1521',
            answer: '12',
          },
          {
            name: '胃灼熱',
            choiceId: '1522',
            answer: '13',
          },
          {
            name: '脹氣',
            choiceId: '1527',
            answer: '18',
          },
          {
            name: '黑便',
            choiceId: '1524',
            answer: '15',
          },
          {
            name: '血便(鮮紅色)',
            choiceId: '1528',
            answer: '19',
          },
          {
            name: '慢性腹瀉',
            choiceId: '1525',
            answer: '16',
          },
          {
            name: '慢性便祕',
            choiceId: '1526',
            answer: '17',
          },
        ],
      },
      {
        diseaseType: '四肢與軀幹肌肉骨骼症狀',
        questionId: '472',
        diseaseOptions: [
          {
            name: '上背痛',
            choiceId: '1531',
            answer: '22',
          },
          {
            name: '下背痛',
            choiceId: '1532',
            answer: '23',
          },
          {
            name: '關節疼痛',
            choiceId: '1533',
            answer: '24',
          },
          {
            name: '手腳麻痛',
            choiceId: '1534',
            answer: '25',
          },
          {
            name: '手腳肌肉無力',
            choiceId: '1535',
            answer: '26',
          },
        ],
      },
      {
        diseaseType: '特殊症狀',
        questionId: '472',
        diseaseOptions: [
          {
            name: '倦怠',
            choiceId: '1536',
            answer: '27',
          },
          {
            name: '體重減輕 ≥ 3公斤',
            choiceId: '1537',
            answer: '28',
          },
          {
            name: '排尿不適',
            choiceId: '1529',
            answer: '20',
          },
          {
            name: '多尿 / 頻尿',
            choiceId: '1530',
            answer: '21',
          },
        ],
      },
    ],
  } as QuestionnaireForm,
  LONG_TERM_MEDICATIONS: {
    questionnaireType: '長期服用藥物',
    questionnaireTypeXCode: 'long_term_medications',
    diseaseGroups: [
      {
        diseaseType: '長期服用藥物',
        questionId: '481',
        diseaseOptions: [
          {
            name: '高血壓藥',
            choiceId: '1576',
            answer: '2',
          },
          {
            name: '高血脂藥',
            choiceId: '1577',
            answer: '3',
          },
          {
            name: '抗凝血劑',
            choiceId: '1578',
            answer: '4',
          },
          {
            name: '心臟病藥',
            choiceId: '1579',
            answer: '5',
          },
          {
            name: '糖尿病藥',
            choiceId: '1580',
            answer: '6',
          },
          {
            name: '腸胃藥',
            choiceId: '1581',
            answer: '7',
          },
          {
            name: '甲狀腺藥',
            choiceId: '1582',
            answer: '8',
          },
          {
            name: '荷爾蒙藥',
            choiceId: '1583',
            answer: '9',
          },
          {
            name: '助眠藥',
            choiceId: '1584',
            answer: '10',
          },
          {
            name: '止痛藥',
            choiceId: '1585',
            answer: '11',
          },
          {
            name: '氣喘藥',
            choiceId: '1586',
            answer: '12',
          },
          {
            name: '尿酸藥',
            choiceId: '1587',
            answer: '13',
          },
          {
            name: '類固醇藥',
            choiceId: '1588',
            answer: '14',
          },
          {
            name: '中藥',
            choiceId: '1589',
            answer: '15',
          },
        ],
      },
    ],
  } as QuestionnaireForm,
  LIFESTYLE_HABITS: {
    questionnaireType: '生活習慣',
    questionnaireTypeXCode: 'lifestyle_habits',
    diseaseGroups: [
      {
        diseaseType: '最近六個月內是否有嚼食檳榔',
        questionId: '485',
        diseaseOptions: [
          {
            name: '從未嚼食檳榔',
            choiceId: '1612',
            answer: '1',
          },
          {
            name: '偶爾嚼(不是天天)',
            choiceId: '1613',
            answer: '2',
          },
          {
            name: '幾乎每天嚼',
            choiceId: '1614',
            answer: '3',
          },
          {
            name: '已經戒食',
            choiceId: '1615',
            answer: '4',
          },
        ],
      },
      {
        diseaseType: '過去一個月內是否有吸菸',
        questionId: '490',
        diseaseOptions: [
          {
            name: '從未吸菸',
            choiceId: '1620',
            answer: '1',
          },
          {
            name: '偶爾(不是天天)',
            choiceId: '1621',
            answer: '2',
          },
          {
            name: '(幾乎)每天吸',
            choiceId: '1622',
            answer: '3',
          },
          {
            name: '已經戒菸',
            choiceId: '1623',
            answer: '4',
          },
        ],
      },
      {
        diseaseType: '過去一個月內是否有喝酒',
        questionId: '495',
        diseaseOptions: [
          {
            name: '從未喝酒',
            choiceId: '1628',
            answer: '1',
          },
          {
            name: '偶爾(不是天天)',
            choiceId: '1629',
            answer: '2',
          },
          {
            name: '(幾乎)每天喝',
            choiceId: '1630',
            answer: '3',
          },
          {
            name: '已經戒酒',
            choiceId: '1631',
            answer: '4',
          },
        ],
      },
      {
        diseaseType: '飲食習慣(可複選)',
        questionId: '501',
        diseaseOptions: [
          {
            name: '以下皆無',
            choiceId: '1637',
            answer: '1',
          },
          {
            name: '全素食',
            choiceId: '1638',
            answer: '2',
          },
          {
            name: '嗜甜/手搖飲',
            choiceId: '1639',
            answer: '3',
          },
          {
            name: '嗜糕點/麵包',
            choiceId: '1640',
            answer: '4',
          },
          {
            name: '嗜肥肉/油炸',
            choiceId: '1641',
            answer: '5',
          },
          {
            name: '每天至少1杯咖啡',
            choiceId: '1642',
            answer: '6',
          },
        ],
      },
    ],
  },
  EXERCISE_HABITS: {
    questionnaireType: '運動習慣',
    questionnaireTypeXCode: 'exercise_habits',
    diseaseGroups: [
      {
        diseaseType: '是否有運動習慣',
        questionId: '502',
        diseaseOptions: [
          {
            name: '無（接續填答 2 - 5）',
            choiceId: '1643',
            answer: '1',
          },
          {
            name: '有（接續填答 5 - 9）',
            choiceId: '1644',
            answer: '2',
          },
        ],
      },
      {
        diseaseType: '能夠舒適走多久',
        questionId: '503',
        diseaseOptions: [
          {
            name: '10分鐘以下',
            choiceId: '1645',
            answer: '1',
          },
          {
            name: '11~30分鐘',
            choiceId: '1646',
            answer: '2',
          },
          {
            name: '31分鐘以上',
            choiceId: '1647',
            answer: '3',
          },
        ],
      },
      {
        diseaseType: '能夠提重物或伏地挺身',
        questionId: '504',
        diseaseOptions: [
          {
            name: '不行',
            choiceId: '1648',
            answer: '1',
          },
          {
            name: '可以',
            choiceId: '1649',
            answer: '2',
          },
        ],
      },
      {
        diseaseType: '運動喜好(可複選)',
        questionId: '505',
        diseaseOptions: [
          {
            name: '健行或跑步',
            choiceId: '1650',
            answer: '1',
          },
          {
            name: '自行車',
            choiceId: '1651',
            answer: '2',
          },
          {
            name: '游泳',
            choiceId: '1652',
            answer: '3',
          },
          {
            name: '舞蹈和有氧體操',
            choiceId: '1653',
            answer: '4',
          },
          {
            name: '球類運動',
            choiceId: '1654',
            answer: '5',
          },
        ],
      },
      {
        diseaseType: '運動禁忌(可複選)',
        questionId: '506',
        diseaseOptions: [
          {
            name: '無',
            choiceId: '1655',
            answer: '1',
          },
          {
            name: '上肢',
            choiceId: '1656',
            answer: '2',
          },
          {
            name: '脊椎、背部',
            choiceId: '1657',
            answer: '3',
          },
          {
            name: '下肢',
            choiceId: '1658',
            answer: '4',
          },
        ],
      },
      {
        diseaseType: '通常進行哪種運動(可複選)',
        questionId: '507',
        diseaseOptions: [
          {
            name: '健行或跑步',
            choiceId: '1659',
            answer: '1',
          },
          {
            name: '自行車',
            choiceId: '1660',
            answer: '2',
          },
          {
            name: '游泳',
            choiceId: '1661',
            answer: '3',
          },
          {
            name: '舞蹈和有氧體操',
            choiceId: '1662',
            answer: '4',
          },
          {
            name: '球類運動',
            choiceId: '1663',
            answer: '5',
          },
          {
            name: '重量訓練',
            choiceId: '1664',
            answer: '6',
          },
        ],
      },
      {
        diseaseType: '每周運動頻率',
        questionId: '508',
        diseaseOptions: [
          {
            name: '30分鐘以下',
            choiceId: '1665',
            answer: '1',
          },
          {
            name: '31-60分鐘',
            choiceId: '1666',
            answer: '2',
          },
          {
            name: '61分鐘以上',
            choiceId: '1667',
            answer: '3',
          },
        ],
      },
      {
        diseaseType: '每次運動時間',
        questionId: '509',
        diseaseOptions: [
          {
            name: '15分鐘以下',
            choiceId: '1668',
            answer: '1',
          },
          {
            name: '16-60分鐘',
            choiceId: '1669',
            answer: '2',
          },
          {
            name: '61分鐘以上',
            choiceId: '1670',
            answer: '3',
          },
        ],
      },
      {
        diseaseType: '運動強度',
        questionId: '510',
        diseaseOptions: [
          {
            name: '輕度 (運動中可輕鬆講話)',
            choiceId: '1671',
            answer: '1',
          },
          {
            name: '中度 (運動中講話有點喘)',
            choiceId: '1672',
            answer: '2',
          },
          {
            name: '高度 (運動中無法講話)',
            choiceId: '1673',
            answer: '3',
          },
        ],
      },
    ],
  },
};

export const NONE_OF_FOLLOWING = '以下皆無';

export const SURGERY_HISTORY_OPTIONS = [
  { name: '無', choiceId: '1572', answer: '1' },
  { name: '有', choiceId: '1573', answer: '2' },
];

export const PREVIOUS_OCCUPATION_CATEGORY_OPTIONS = [
  { name: '服務業', choiceId: '1702', answer: '1' },
  { name: '出版、影音製作、傳播及資通訊服務業', choiceId: '1703', answer: '2' },
  { name: '製造業', choiceId: '1704', answer: '3' },
  { name: '金融及保險業', choiceId: '1705', answer: '4' },
  { name: '營建工程業', choiceId: '1706', answer: '5' },
  { name: '批發及零售業', choiceId: '1707', answer: '6' },
  { name: '運輸及倉儲業', choiceId: '1708', answer: '7' },
  { name: '不動產業', choiceId: '1709', answer: '8' },
  { name: '住宿及餐飲業', choiceId: '1710', answer: '9' },
  { name: '農、林、漁、牧業', choiceId: '1711', answer: '10' },
  { name: '礦產及土石採取業', choiceId: '1712', answer: '11' },
  { name: '電力及燃氣供應業', choiceId: '1713', answer: '12' },
  { name: '用水供應及污染整治業', choiceId: '1714', answer: '13' },
  { name: '公共行政及國防；強制性社會安全', choiceId: '1715', answer: '14' },
  { name: '教育業', choiceId: '1716', answer: '15' },
  { name: '專業、科學及技術服務業', choiceId: '1717', answer: '16' },
  { name: '醫療保健及社會工作服務業', choiceId: '1718', answer: '17' },
  { name: '藝術、娛樂及休閒服務業', choiceId: '1719', answer: '18' },
  { name: '其他', choiceId: '1720', answer: '19' },
];

export const CURRENT_OCCUPATION_CATEGORY_OPTIONS = [
  { name: '服務業', choiceId: '1724', answer: '1' },
  { name: '出版、影音製作、傳播及資通訊服務業', choiceId: '1725', answer: '2' },
  { name: '製造業', choiceId: '1726', answer: '3' },
  { name: '金融及保險業', choiceId: '1727', answer: '4' },
  { name: '營建工程業', choiceId: '1728', answer: '5' },
  { name: '批發及零售業', choiceId: '1729', answer: '6' },
  { name: '運輸及倉儲業', choiceId: '1730', answer: '7' },
  { name: '不動產業', choiceId: '1731', answer: '8' },
  { name: '住宿及餐飲業', choiceId: '1732', answer: '9' },
  { name: '農、林、漁、牧業', choiceId: '1733', answer: '10' },
  { name: '礦產及土石採取業', choiceId: '1734', answer: '11' },
  { name: '電力及燃氣供應業', choiceId: '1735', answer: '12' },
  { name: '用水供應及污染整治業', choiceId: '1736', answer: '13' },
  { name: '公共行政及國防；強制性社會安全', choiceId: '1737', answer: '14' },
  { name: '教育業', choiceId: '1738', answer: '15' },
  { name: '專業、科學及技術服務業', choiceId: '1739', answer: '16' },
  { name: '醫療保健及社會工作服務業', choiceId: '1740', answer: '17' },
  { name: '藝術、娛樂及休閒服務業', choiceId: '1741', answer: '18' },
  { name: '其他', choiceId: '1742', answer: '19' },
];

// 是否需輪班
export const NEEDS_SHIFT_OPTIONS = [
  { name: '否', choiceId: '1746', answer: '1' },
  { name: '是', choiceId: '1747', answer: '2' }, // 跟 Joey 討論後選擇不顯示是的選項
];

// 輪班制
export const SHIFT_TYPE_OPTIONS = [
  { name: '兩班制', choiceId: '1748', answer: '1' },
  { name: '三班制', choiceId: '1749', answer: '2' },
  { name: '四班制', choiceId: '1750', answer: '3' },
  { name: '其他輪班方式', choiceId: '1751', answer: '4' },
];

// 檢查時期（健檢原因）
export const EXAM_REASON_OPTIONS = [
  { name: '新進員工(受僱時)', choiceId: '1755', answer: '1' },
  { name: '定期檢查', choiceId: '1756', answer: '2' },
];

// 常住國家
export const RESIDENCE_COUNTRY_OPTIONS = [
  { name: '中華民國', choiceId: '1674', answer: '1' },
  { name: '中國(港澳)', choiceId: '1675', answer: '2' },
  { name: '日韓', choiceId: '1676', answer: '3' },
  { name: '美加', choiceId: '1677', answer: '4' },
  { name: '歐洲', choiceId: '1678', answer: '5' },
  { name: '其他', choiceId: '1679', answer: '6' },
];

// 婚姻狀態
export const MARITAL_STATUS_OPTIONS = [
  { name: '未婚', choiceId: '1681', answer: '1' },
  { name: '已婚', choiceId: '1682', answer: '2' },
  { name: '鰥寡', choiceId: '1683', answer: '3' },
  { name: '離婚', choiceId: '1684', answer: '4' },
];

// 教育程度
export const EDUCATION_LEVEL_OPTIONS = [
  { name: '國中(含)以下', choiceId: '1685', answer: '1' },
  { name: '高中', choiceId: '1686', answer: '2' },
  { name: '專科', choiceId: '1687', answer: '3' },
  { name: '大學', choiceId: '1688', answer: '4' },
  { name: '研究所以上', choiceId: '1689', answer: '5' },
];

// 職位
export const POSITION_OPTIONS = [
  { name: '負責人', choiceId: '1690', answer: '1' },
  { name: '高階主管', choiceId: '1691', answer: '2' },
  { name: '中階主管', choiceId: '1692', answer: '3' },
  { name: '基層主管', choiceId: '1693', answer: '4' },
  { name: '內勤事務', choiceId: '1694', answer: '5' },
  { name: '外務', choiceId: '1695', answer: '6' },
  { name: '專業人員', choiceId: '1696', answer: '7' },
  { name: '技術人員', choiceId: '1697', answer: '8' },
  { name: '其他', choiceId: '1698', answer: '9' },
];

// ========== 作業經歷相關的 questionId 對應 ==========

// 作業經歷 - questionId 對應表
export const OCCUPATION_QUESTION_IDS = {
  // 曾經從事職業
  PREVIOUS_OCCUPATION_CATEGORY: '519',          // 曾經從事行業 (choiceId: 1702 ~ 1720)
  PREVIOUS_OCCUPATION_OTHER: '520',             // 曾經從事行業其他說明 (choiceId: 1721)
  PREVIOUS_OCCUPATION_START_DATE: '521',        // 起始日期 (choiceId: 1722)
  PREVIOUS_OCCUPATION_END_DATE: '522',          // 截止日期 (choiceId: 1723)
  
  // 目前從事職業
  CURRENT_OCCUPATION_CATEGORY: '523',             // 目前從事行業 (choiceId: 1724 ~ 1742)
  CURRENT_OCCUPATION_OTHER: '524',                // 請填寫目前從事行業 (choiceId: 1743)
  CURRENT_OCCUPATION_EMPLOYMENT_DATE: '525',      // 起始日期 (choiceId: 1744)
  CURRENT_OCCUPATION_EMPLOYMENT_END_DATE: '526',  // 截止日期 (choiceId: 1745)
  
  // 輪班相關
  NEEDS_SHIFT: '527',                           // 是否需輪班 (choiceId: 1746, 1747)
  SHIFT_TYPE: '528',                            // 輪班制 (choiceId: 1748 ~ 1751)
  SHIFT_TYPE_OTHER: '529',                      // 請填寫輪班方式 (choiceId: 1752)
  
  // 工作時數與原因
  AVG_WORK_HOURS_PAST_MONTH: '530',             // 過去一個月,平均每週工時(每週工作日×每日工時) (choiceId: 1753)
  AVG_WORK_HOURS_PAST_SIX_MONTHS: '531',        // 過去六個月,平均每週工時(每週工作日×每日工時) (choiceId: 1754)
  EXAM_REASON: '532',                           // 檢查時期（原因）(choiceId: 1755, 1756)
  AVG_SLEEP_TIME: '533',                        // 平均睡眠時間 (choiceId: 1757)
};

// 作業經歷 - choiceId 對應表
export const OCCUPATION_CHOICE_IDS = {
  PREVIOUS_OCCUPATION_OTHER: '1721',
  PREVIOUS_OCCUPATION_START_DATE: '1722',
  PREVIOUS_OCCUPATION_END_DATE: '1723',
  CURRENT_OCCUPATION_OTHER: '1743',
  CURRENT_OCCUPATION_EMPLOYMENT_DATE: '1744',
  CURRENT_OCCUPATION_EMPLOYMENT_END_DATE: '1745',
  SHIFT_TYPE_OTHER: '1752',
  AVG_WORK_HOURS_PAST_MONTH: '1753',
  AVG_WORK_HOURS_PAST_SIX_MONTHS: '1754',
  AVG_SLEEP_TIME: '1757',
};